var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check",
    clipPath: "url(#clip0_15619_1258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3333 17.7187V16.0521C13.3333 15.168 12.9821 14.3202 12.3569 13.6951C11.7318 13.0699 10.884 12.7187 9.99992 12.7187H4.16658C3.28253 12.7187 2.43468 13.0699 1.80956 13.6951C1.18444 14.3202 0.833252 15.168 0.833252 16.0521V17.7187M14.1666 9.38542L15.8333 11.0521L19.1666 7.71875M10.4166 6.05208C10.4166 7.89303 8.9242 9.38542 7.08325 9.38542C5.2423 9.38542 3.74992 7.89303 3.74992 6.05208C3.74992 4.21113 5.2423 2.71875 7.08325 2.71875C8.9242 2.71875 10.4166 4.21113 10.4166 6.05208Z",
    stroke: "#038A4D",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15619_1258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.21875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/userCheck.001ee6e1a2678072295f986a516fd988.svg";
export { ForwardRef as ReactComponent };